// 1 year
export const COOKIE_LIFETIME_SECONDS = 365 * 24 * 60 * 60;

export type SupportedLanguage = 'en' | 'et' | 'lv';